import styled from 'styled-components';

const Wrapper = styled.div`
  z-index: 999999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  background-color: #2d1441;

  & > header {
    padding-top: 32px;
    display: flex;
    justify-content: center;
  }
`;

const ContainerStyled = styled.div`
  box-shadow: inset 0px 0px 46px 15px rgb(15, 1, 29);
  background: #4d008c;
  position: absolute;
  display: flex;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  & > div {
    max-width: 220px;
    align-items: center;
    margin: auto;
  }
`;

export { Wrapper, ContainerStyled };
